import { JsonStorage } from "../../utils/storage/JsonStorage";
import { LocalStorageKey } from "../../utils/enums";

export default class SponsorAdStorage {
  static dbName = LocalStorageKey.SPONSOR_AD;

  static getSponsorAdStatus(adId: string) {
    let data = JsonStorage.getData(this.dbName);
    return data[adId];
  }

  static setSponsorAdStatus(adId: string, status: boolean) {
    let data = JsonStorage.getData(this.dbName);
    data[adId] = status;
    JsonStorage.setData(this.dbName, data);
  }
}
